var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"manager-drawer-group",attrs:{"dense":""}},[_c('h3',{staticClass:"subheader"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.visibleTabs),function(tab){return _c('manager-drawer-item',{key:tab.html,attrs:{"tab":tab,"is-tab-selected":_vm.isTabSelected(tab)},on:{"selectTab":_vm.selectTab}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }